export default "__VITE_ASSET__1de4b9d6__"